<template>
  <div class="container">
    <!-- 保修详情信息 -->
    <div class="warranty-details-info">
      <div class="warranty-details-info-title">巡检信息</div>
      <div class="warranty-details-info-content">
        <div class="warranty-details-info-content-left">
          <span>巡检位置：</span>
          <span>{{detailsList.inspectionAddress}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>申请时间：</span>
          <span>{{detailsList.inspectionDate}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>巡检人：</span>
          <span>{{detailsList.userName}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>联系人：</span>
          <span>{{detailsList.name}}</span>
        </div>
        <div class="warranty-details-info-content-left">
          <span>联系电话：</span>
          <span>{{detailsList.phone}}</span>
        </div>
        <div class="warranty-details-info-content-left clearfix">
          <span class="more-title">巡检情况：</span>
          <span class="more-content">{{detailsList.description}}</span>
        </div>
        <div class="warranty-details-info-img">
          <div>上传图片：</div>
          <div  v-if="pictureList.length">
            <img
              v-for="(item,index) in pictureList"
              :key="index"
              class="more-img"
              :src="item.url"
              alt
              srcset
              @click="HandleclickImg(index)"
            />
          </div>
            <div v-else>
            <img class="no-img" src="@/images/noupload.png" alt srcset />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Step, Steps } from "vant";
import { inspectionDetails } from "@/api/inspection";
import { ImagePreview } from "vant";
export default {
  components: {
    vanStep: Step,
    vanSteps: Steps
  },
  data() {
    return {
      detailsList: {},
      planList: [],
      activeIndex: null,
      pictureList: [],
      ImagePreview:[],
      show:'',
      imagepreview:''
  
    };
  },

  mounted() {
    // 获取详情列表的参数
    console.log(this.$route.query)
    this.requestInspectionDetails();
    if (window.history && window.history.pushState) {
      console.log(window.history)
      console.log(window.history.pushState)
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.fun, false); //false阻止默认事件
    }
  },
   destroyed(){
     window.removeEventListener('popstate', this.fun, false);//false阻止默认事件
   },
  methods: {
        fun() {
      if(this.show) {
         this.show = false
         this.imagepreview.close()
           history.pushState(null, null, document.URL);
      }else {
          // histroy.back()
          window.history.go(-1);
      }
    },
      // 获取详情
      requestInspectionDetails() {
          let id = this.$route.query.id
          inspectionDetails({id:id}).then(res=>{
              console.log(res)
              this.detailsList = res.data
              this.pictureList = res.data.pictureList
              res.data.pictureList.forEach(element => {
                  console.log(element)
                  this.ImagePreview.push(element.url)
              });

          })
      },
      //点击查看大图
      HandleclickImg(index) {
        this.show = true;
        this.imagepreview = ImagePreview({
            images:this.ImagePreview,
            startPosition: index,
        onClose() {
            this.show = false
         }
          });
      }
  },

};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  // 保修信息
  .warranty-details-info {
    width: 350px;
    margin: 10px 13px;
    background-color: #ffffff;
    text-align: left;
    border-radius: 10px;
    .warranty-details-info-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      color: #404051;
      font-size: 16px;
      font-weight: bold;
    }
    .warranty-details-info-content {
      width: 100%;
      padding: 15px 15px;
      box-sizing: border-box;
      color: #404051;
      font-size: 14px;
      //  每一行的信息
      .warranty-details-info-content-left {
        position: relative;
        margin: 15px 0;
        span {
          &:first-child {
            display: inline-block;
            width: 85px;
            padding: 5px;
            box-sizing: border-box;
            color: #999999;
          }
          &:last-child {
            display: inline-block;
            width: 203px;
            color: #333333;
            margin-left: 30px;
          }
        }
        .more-img {
          width: 30px;
          height: 30px;
          margin-right: 5px;
          &:first-of-type {
            margin-left: 117px !important;
          }
        }
        // 问题描述
        .more-title {
          display: inline-block;
          width: 85px;
          padding: 5px;
          position: absolute;
          top: 0;
        }
        .more-content {
          margin-left: 117px !important;
        }
      }
      // 处理图片的左右布局
      .warranty-details-info-img {
        display: flex;
        margin-top: 30px;
        div {
          &:first-child {
            width: 110px;
            color: #999999;
            padding: 5px;
            box-sizing: border-box;
          }
          .more-img {
            width: 30px;
            height: 30px;
          }
          .no-img {
          width: 60px;
          height: 60px;
          margin-right: 5px;
        }
        }
      }
    }
  }
  // 处理进度
  .warranty-details-steps {
    width: 350px;
    margin: 10px 13px;
    background-color: #ffffff;
    text-align: left;
    border-radius: 10px;
    .warranty-details-info-title {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;
      color: #404051;
      font-size: 16px;
      span {
        font-weight: bold;
      }
      .steps-status {
        font-size: 14px;
        color: #404051;
        float: right;
        font-weight: normal;
      }
    }
  }
}
</style>
<style lang="scss">
//   处理vant进度条的样式
.warranty-details-steps {
  .van-step__circle {
    width: 15px;
    height: 15px;
    background-color: #008fff;
  }

  .van-icon-checked {
    &::before {
      font-size: 19px;
      color: #008fff;
    }
  }
  .van-step__line {
    background-color: #008cff;
  }
  .van-step__title {
    h3 {
      color: #333333;
      font-size: 15px;
      font-weight: bold;
    }
    p {
      font-size: 13px;
      color: #999999;
    }
  }
}
</style>